import { areAdminNewOrderNotificationsEnabled } from './adminNewOrderNotificationsPreference'
import { createNewOrderNotifyDedupe } from './newOrderNotifyDedupe'
import { playNewOrderSound } from './playNewOrderSound'
import { shouldNotifyNewOrder } from './shouldNotifyNewOrder'
import { showNewOrderNotification } from './showNewOrderNotification'

/** Дедуп-инстанс уведомлений о заказах */
export type NewOrderNotifyDedupe = ReturnType<typeof createNewOrderNotifyDedupe>

/**
 * Параметры обработки входящего нового заказа (сокет или poll).
 * @param orderId — id заказа
 * @param orderPizzeriaId — пиццерия заказа
 * @param totalPrice — сумма заказа (для poll может быть 0, если эндпоинт не отдаёт)
 * @param filterPizzeriaId — текущий фильтр пиццерии из Redux
 * @param dedupe — инстанс дедупа
 * @param onOpenOrder — открытие деталей заказа по клику на Notification
 * @param onRefetchHome — refetch списка/сводки, если открыта главная
 */
export type ProcessIncomingNewOrderParams = {
  orderId: number
  orderPizzeriaId: number
  totalPrice: number
  filterPizzeriaId: number | null
  dedupe: NewOrderNotifyDedupe
  onOpenOrder: (orderId: number) => void
  onRefetchHome?: () => void
}

/**
 * Дедуп + фильтр + звук + Browser Notification + опциональный refetch главной.
 * @param params — параметры входящего заказа
 * @returns true, если уведомление реально показано
 */
export const processIncomingNewOrder = (
  params: ProcessIncomingNewOrderParams
): boolean => {
  const {
    orderId,
    orderPizzeriaId,
    totalPrice,
    filterPizzeriaId,
    dedupe,
    onOpenOrder,
    onRefetchHome,
  } = params

  if (!areAdminNewOrderNotificationsEnabled()) {
    return false
  }

  if (dedupe.has(orderId)) {
    return false
  }

  if (
    !shouldNotifyNewOrder({
      filterPizzeriaId,
      orderPizzeriaId,
    })
  ) {
    return false
  }

  dedupe.remember(orderId)
  playNewOrderSound()
  showNewOrderNotification({
    orderId,
    totalPrice,
    onClick: () => onOpenOrder(orderId),
  })
  onRefetchHome?.()

  return true
}
